export default {
  path: "/carregadores",
  name: "Chargers",
  component: () => import("@/presentation/views/Chargers/Chargers.vue"),
  meta: { requiresAuth: true, allowPermission: "chargers:list" },
  redirect: { name: "ChargersList" },
  list: {
    path: "lista",
    name: "ChargersList",
    component: () =>
      import("@/presentation/views/Chargers/ChargersList/ChargersList.vue"),
  },

  detail: {
    path: "detalhes/:id",
    name: "ChargerDetail",
    component: () =>
      import("@/presentation/views/Chargers/ChargerDetail/ChargerDetail.vue"),
    redirect: { name: "ChargerDetailInfo" },
    connectors: {
      path: "conectores",
      name: "ChargerDetailConnectors",
      component: () =>
        import(
          "@/presentation/views/Chargers/ChargerDetail/ChargerDetailConnectors/ChargerDetailConnectors.vue"
        ),
    },
    info: {
      path: "informacoes",
      name: "ChargerDetailInfo",
      component: () =>
        import(
          "@/presentation/views/Chargers/ChargerDetail/ChargerDetailInfo/ChargerDetailInfo.vue"
        ),
    },
    activity_log: {
      path: "registro-de-atividades",
      name: "ChargerDetailActivityLog",
      component: () =>
        import(
          "@/presentation/views/Chargers/ChargerDetail/ChargerDetailActivityLog/ChargerDetailActivityLog.vue"
        ),
    },
    partnership_info: {
      path: "detalhe-da-parceria",
      name: "ChargerDetailPartnerhsipInfo",
      component: () =>
        import(
          "@/presentation/views/Partnerships/PartnershipInfoTab/PartnershipInfoTab.vue"
        ),
    },
    iot_config: {
      path: "configuracao-iot",
      name: "ChargerDetailIoTConfig",
      component: () =>
        import(
          "@/presentation/views/Chargers/ChargerDetail/ChargerDetailIoTConfig/ChargerDetailIoTConfig.vue"
        ),
    },
  },
  add: {
    path: "adicionar",
    name: "AddCharger",
    component: () =>
      import("@/presentation/views/Chargers/AddCharger/AddCharger.vue"),
  },
  edit: {
    path: "editar/:id",
    name: "EditCharger",
    component: () =>
      import("@/presentation/views/Chargers/EditCharger/EditCharger.vue"),
  },
} as const;
